import {
  ResponsiveContainer,
  XAxis,
  YAxis,
  ZAxis,
  ScatterChart,
  Scatter,
  Label,
  LabelList,
  ReferenceLine,
  Tooltip
} from "recharts";
import React, { useState, useEffect } from "react";
import { numberFormatter } from "../../utils";
const GrossMarginChart1 = (props: any) => {
  const [data, setData] = useState([]);
  const refX = props?.performanceGraphData?.weightedCagr*100;
  const refY = props?.performanceGraphData?.weightedGM*100;
  const {selectedMaskStatus,selectedVendor,supplier} = props;
  useEffect(() => {
    if (props?.performanceGraphData) {
      setData(props.performanceGraphData?.peer);
    }
  }, [props]);

 const customTooltip = ({ active, payload }: any) => {
      if (active && payload && payload.length) {
        const data = payload[0].payload;
        return (
          <div className="custom-tooltip">
            <p className="label" style={{ padding: "0", margin: "0" }}>
              <label
                style={{
                  color: "black",
                  fontSize: "10px",
                  fontWeight: "normal",
                }}
              >
                Supplier :{" "}
              </label>
              <label
                style={{
                  color: "black",
                  fontSize: "10px",
                  fontWeight: "bold",
                }}
              >
                {data.peer_vendor_name}
              </label>
            </p>
            <p className="label" style={{ padding: "0", margin: "0" }}>
              <label
                style={{
                  color: "black",
                  fontSize: "10px",
                  fontWeight: "normal",
                }}
              >
                Spend :{" "}
              </label>
              <label
                style={{
                  color: "black",
                  fontSize: "10px",
                  fontWeight: "bold",
                }}
              >
                {numberFormatter(data.invCost,0,'$')}
              </label>
            </p>
              <p className="label" style={{ padding: "0", margin: "0" }}>
              <label
                style={{
                  color: "black",
                  fontSize: "10px",
                  fontWeight: "normal",
                }}
              >
                5 Year CAGR :{" "}
              </label>
              <label
                style={{
                  color: "black",
                  fontSize: "10px",
                  fontWeight: "bold",
                }}
              >
                {numberFormatter(data.cagr,0)}%
              </label>
            </p>
              <p className="label" style={{ padding: "0", margin: "0" }}>
              <label
                style={{
                  color: "black",
                  fontSize: "10px",
                  fontWeight: "normal",
                }}
              >
                Last Year Gross Margin %​ :{" "}
              </label>
              <label
                style={{
                  color: "black",
                  fontSize: "10px",
                  fontWeight: "bold",
                }}
              >
                {numberFormatter(data.gm,0)}%
              </label>
            </p>
          </div>
        );
      }
    };
  return (
    <div className="w-[29vw] flex flex-col items-center h-[32vh] p-1 ">
      <ResponsiveContainer width="100%" height="100%">
        <ScatterChart
          width={400}
          height={400}
          margin={{
            top: 30,
            right: 50,
            bottom: 20,
            left: 30,
          }}
        >
          <XAxis
            type="number"
            dataKey="cagr"
            stroke="black"
            tickFormatter={(val) => `${numberFormatter(val, 0)}%`}
            domain={['dataMin - 5', 'dataMax + 5']}
          >
            <Label
              value="5 Year CAGR"
              offset={0}
              position="bottom"
              style={{ fill: "black" }}
            />
          </XAxis>
          <YAxis
            type="number"
            dataKey="gm"
            stroke="black"
            interval={0}
            tickFormatter={(val) => `${numberFormatter(val, 0)}%`}
            domain={['dataMin - 5', 'dataMax + 5']}
          >
            <Label
              value={`Last Year Gross Margin %​`}
              angle={-90}
              offset={0}
              position="insideLeft"
              style={{ fill: "black", textAnchor: "middle" }}
            />
          </YAxis>
          <ZAxis type="number" dataKey="invCost" range={data?.length <= 10 ? [100, 1000] : [50, 200]}></ZAxis>
          <ReferenceLine x={refX} label={{ position: 'top', fill: 'black', value: numberFormatter(refX, 2) + '%', fontStyle: 'italic' }} stroke="black" strokeDasharray="5 3" opacity={0.3} />
          <ReferenceLine y={refY} label={{ position: 'right', fill: 'black', value: numberFormatter(refY, 2) + '%', fontStyle: 'italic' }} stroke="black" strokeDasharray="5 3" opacity={0.3} />
            <Tooltip
              contentStyle={{
                color: "black",
                backgroundColor: "black",
                border: "1px solid black",
              }}
              cursor={{ strokeDasharray: "3 3", fill: "#212121" }}
              content={customTooltip}
            />
          {data?.map((d: any, index: number) => {
            return (
              <>
              {supplier?.includes(d?.peer_vendor_name)&&<Scatter
                key={index}
                data={[d]}
                fill={d?.peer_vendor_name===selectedVendor[0] ?"#2ba1c3":'#faf275'}
              >
                {!selectedMaskStatus &&<LabelList dataKey="peer_vendor_name" fill="black" fontSize={'1.4vh'} position={'right'}/>}
              </Scatter>}
              </>
            );
          })}
        </ScatterChart>
      </ResponsiveContainer>
    </div>
  );
};
export default GrossMarginChart1;
